import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import './CompanyHistory.css';

const ESG = () => {
  const [activeSection, setActiveSection] = useState('environment');
  
  const sidebarItems = [
    { name: '환경', path: 'environment' },
    { name: '사회', path: 'social' },
    { name: '지배구조', path: 'governance' }
  ];

  // 스크롤 스파이 기능
  useEffect(() => {
    const handleScroll = () => {
      const sections = sidebarItems.map(item => item.path);
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Sidebar 
        category="ESG" 
        items={sidebarItems} 
        activeSection={activeSection}
        onItemClick={scrollToSection}
      />
      <div className="company-history-page">
        <div className="history-container">
          <h1 className="page-category-title">ESG</h1>
          
          {/* 환경 섹션 */}
          <section id="environment" className="section">
            <h2 className="section-title">환경 (Environment)</h2>
            <div className="section-container">
              <div className="esg-grid">
                <div className="esg-item">
                  <img src="/esg/E-1.환경경영 방침(2025년).png" alt="환경경영 방침" className="esg-image" />
                  <h3 className="esg-title">환경경영 방침</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/E-2.환경전략5대정책(2025년).png" alt="환경전략 5대정책" className="esg-image" />
                  <h3 className="esg-title">환경전략 5대정책</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/E-3.온실가스배출량-환경성과지표의미.png" alt="온실가스 배출량" className="esg-image" />
                  <h3 className="esg-title">온실가스 배출량</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/E-4.온실가스배출량-환경관리지표의미.png" alt="온실가스 배출량2" className="esg-image" />
                  <h3 className="esg-title">온실가스 배출량2</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/E-5.친환경공사납품실적.png" alt="친환경공사납품실적" className="esg-image" />
                  <h3 className="esg-title">친환경공사납품실적</h3>
                </div>
              </div>
            </div>
          </section>

          {/* 사회 섹션 */}
          <section id="social" className="section">
            <h2 className="section-title">사회 (Social)</h2>
            <div className="section-container">
              <div className="esg-grid">
                <div className="esg-item">
                  <img src="/esg/S-0.근로자 인권보호.png" alt="근로자 인권보호" className="esg-image" />
                  <h3 className="esg-title">근로자 인권보호</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/S-1.안전보건 방침(2025년).png" alt="안전보건 방침" className="esg-image" />
                  <h3 className="esg-title">안전보건 방침</h3>
                </div>
              </div>
            </div>
          </section>

          {/* 지배구조 섹션 */}
          <section id="governance" className="section">
            <h2 className="section-title">지배구조 (Governance)</h2>
            <div className="section-container">
              <div className="esg-grid">
                <div className="esg-item">
                  <img src="/esg/G-1.ESG 개요.png" alt="ESG 개요" className="esg-image" />
                  <h3 className="esg-title">ESG 개요</h3>
                </div>
                <div className="esg-item">
                  <img src="/esg/G-2.경영안정성.png" alt="경영안정성" className="esg-image" />
                  <h3 className="esg-title">경영안정성</h3>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default ESG;
